import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    invitedTo: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the invited-to workspace list item */
            invitedTo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InvitedToNavItem.invitedTo?c=2j276edfn4uj6", defaultMessage: "Invited to" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
